import React from 'react';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import { CloseIcon } from '../icons';
import './modal.scss';

interface Props {
    children: any[];
    className: string;
    onClose: () => {};
    isOpen: boolean;
}
export default class Modal extends React.Component<Props> {
    public static propTypes = {
        children: PropTypes.array,
        className: PropTypes.string,
        onClose: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
    };

    public componentWillMount() {
        document.addEventListener( 'keydown', this.handleEscClose );
    }

    public componentWillUnmount() {
        document.removeEventListener( 'keydown', this.handleEscClose );
        document.body.classList.remove( 'modal-open' );
    }

    public componentWillReceiveProps( nextProps: Props ) {
        if ( nextProps.isOpen ) {
            document.body.classList.add( 'modal-open' );
        } else {
            document.body.classList.remove( 'modal-open' );
        }
    }

    public closeModal = (event: any) => {
        event.preventDefault();
        this.props.onClose();
    }

    public handleEscClose = ( event: any ) => {
        const keyCode = event.which;

        if ( keyCode === 27 ) {
            this.props.onClose();
        }
    }

    public stopBubbling = (event: any) => {
        event.stopPropagation();
    }

    public render() {
        const { isOpen, className } = this.props;
        const classes = className ? 'modal-container ' + className : 'modal-container';

        return (
            <CSSTransition
                in={isOpen}
                timeout={320}
                classNames="ani-modal"
                unmountOnExit
            >
                { isOpen &&
                    <div className="modal-backdrop" onClick={this.closeModal}>
                        <div className={classes} onClick={this.stopBubbling}>
                            <a href="#" className="btn-close" onClick={this.closeModal}>
                                <CloseIcon />
                            </a>
                            <div className="modal-contents">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                }
            </CSSTransition>
        );
    }
}
